export enum AudienceMode {
  ALL = 'ALL',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  CSV = 'CSV',
}
